import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import useInitialRender from '../../../hooks/useInitialRender';

function ScrollIntoView({ trigger, shouldRunOnInitialRender = true }) {
  const ref = useRef(null);

  const initialRender = useInitialRender();

  useEffect(() => {
    if (!initialRender || shouldRunOnInitialRender) {
      ref.current && ref.current.scrollIntoView();
    }
  }, [trigger]);

  return <div ref={ref}></div>;
}

ScrollIntoView.propTypes = {
  /**
   * The trigger
   */
  trigger: PropTypes.any,
  /**
   * The run on initial render flag
   */
  shouldRunOnInitialRender: PropTypes.bool
};

export default ScrollIntoView;
